
import * as asyncActionCreator from '../../redux/actionCreators/async';

export default function OnEnterLoadAdminContacts(store) {
  return (nextState, replace, done) => {
    const state = store.getState();

    return Promise.resolve(store.dispatch(asyncActionCreator.searchContacts([])))
      .then(() => done())
      .catch( (err) => {
         return done(err || new Error('An error occurred in OnEnterLoadAdminContacts.'));
      });
  };
}



// WEBPACK FOOTER //
// ./shared/react/OnEnterHooks/loadAdminContacts.js